import React, { useState, useEffect } from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import { Auth0Provider, useAuth0 } from '@auth0/auth0-react';
import Layout from './components/Layout';
import Home from './components/Home';
import Chatbot from './components/Chatbot';
import Defesa from './components/Defesa';
import Payment from './components/Payment';
import AuthScreen from './components/AuthScreen';
import DiagnosticTool from './components/DiagnosticTool';
import { setAuth0TokenGetter } from './services/api';

// Main App Content Component (only renders when authenticated)
function AppContent() {
  const [selectedAccords, setSelectedAccords] = useState([]);
  const [accordLimitAlert, setAccordLimitAlert] = useState(false);
  const { getAccessTokenSilently } = useAuth0();

  // Initialize the API client with Auth0 token getter
  useEffect(() => {
    setAuth0TokenGetter(getAccessTokenSilently);
  }, [getAccessTokenSilently]);

  const handleAccordClick = (accord) => {
    setSelectedAccords((prevSelectedAccords) => {
      // Check if accord is already selected
      if (prevSelectedAccords.some((a) => a.id === accord.id)) {
        return prevSelectedAccords;
      }
      
      // Check if limit is reached
      if (prevSelectedAccords.length >= 10) {
        setAccordLimitAlert(true);
        // Hide alert after 5 seconds
        setTimeout(() => setAccordLimitAlert(false), 5000);
        return prevSelectedAccords;
      }
      
      return [...prevSelectedAccords, accord];
    });
  };

  // Replace the selection with the cases pre-selected for an uploaded case (the 10 most similar
  // by the retrieval vectors, most similar first). The user then confirms or changes it on the map.
  const handlePreselectAccords = (accords) => {
    if (!accords || accords.length === 0) {
      return;
    }
    setSelectedAccords(accords.slice(0, 10));
  };

  const handleRemoveAccord = (id) => {
    setSelectedAccords((prevSelectedAccords) =>
      prevSelectedAccords.filter((accord) => accord.id !== id)
    );
  };

  return (
    <Router>
      <Layout>
        <Routes>
          <Route
            path="/"
            element={
              <Home
                selectedAccords={selectedAccords}
                onAccordClick={handleAccordClick}
                onRemoveAccord={handleRemoveAccord}
                onPreselectAccords={handlePreselectAccords}
                accordLimitAlert={accordLimitAlert}
              />
            }
          />
          <Route
            path="/chat"
            element={<Chatbot selectedAccords={selectedAccords} />}
          />
          <Route
            path="/defesa"
            element={
              <Defesa
                selectedAccords={selectedAccords}
                onPreselectAccords={handlePreselectAccords}
                onRemoveAccord={handleRemoveAccord}
              />
            }
          />
          <Route path="/payment" element={<Payment />} />
          <Route 
            path="/diagnostic" 
            element={<DiagnosticTool selectedAccords={selectedAccords} />} 
          />
        </Routes>
      </Layout>
    </Router>
  );
}

// Authentication Router Component
function AuthRouter() {
  const { isAuthenticated, isLoading } = useAuth0();

  if (isLoading) {
    return (
      <div style={{ 
        display: 'flex', 
        justifyContent: 'center', 
        alignItems: 'center', 
        height: '100vh',
        backgroundColor: '#FAFAFA'
      }}>
        <div>Carregando...</div>
      </div>
    );
  }

  return isAuthenticated ? <AppContent /> : <AuthScreen />;
}

function App() {

  return (
    <Auth0Provider
      domain="dev-i6gtma6v5gi418os.us.auth0.com"
      clientId="htdf5kTGPbthxpwAv7ERrNfkHb3Al82K"
      authorizationParams={{
        redirect_uri: window.location.origin
      }}
    >
      <AuthRouter />
    </Auth0Provider>
  );
}

export default App;
